import { render } from "./CompPropertyView.vue?vue&type=template&id=e0ce0ca4&scoped=true"
import script from "./CompPropertyView.vue?vue&type=script&lang=js"
export * from "./CompPropertyView.vue?vue&type=script&lang=js"

import "./CompPropertyView.vue?vue&type=style&index=0&id=e0ce0ca4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0ce0ca4"]])

export default __exports__